@if (hint()) {
  <ui-form-field-hint-details [hint]="hint()" [hintInfo]="hintInfo()" />
}

@if (rightHint()) {
  <ui-form-field-hint-details [hint]="rightHint()" [hintInfo]="rightHintInfo()" [position]="'right'" />
}
